module.exports = __webpack_public_path__ + "static/cpa-2024-banner-ee28b0c3676bfa0b749f9a1fedf07314.jpg";